import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// import required modules
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import ProductTile from '@pages/ProductListing/view/components/ProductTile';
import { resetPreSelectedFilters } from '@common/utils/utils';
// import { useAppSelector } from 'store/hooks';
// import { selectWishlistItems } from 'store/slices/wishlistSlice';
// import { selectCartItems } from 'store/slices/cartSlice';
// import { useProductStatus } from 'hooks/useProductStatus';

function Favourites({ gridGap, actionTitle, data, autoplay, showAddToCart = true, setCartData, cartData = { cartItem: [] } }) {
  const swiperRef = useRef(null);
  // const cartItems = useAppSelector(selectCartItems)
  // const { getCartQuantity, getProductInStock, isInWishlist } = useProductStatus();
  // const wishlistItems = useAppSelector(selectWishlistItems)

  const addToCartHandleChange = () => {
    console.log('Add to cart button clicked');
  }

  const swiperAutoplayOptions = {
    delay: 2500,
    // disableOnInteraction: false,
  }

  return (
    <div className='lyt-favourites lyt-favourites--typ-navigation'>
      <div className='lyt-favourites__carousel-wrap'>
        <Swiper
          grabCursor={true}
          slidesPerView='auto'
          spaceBetween={gridGap}
          modules={[Navigation, Pagination, Autoplay]}
          className={`lyt-favourites__swiper-container ${data.length >= 5 && window.innerWidth > 1024 ? '' : 'lyt-favourites__swiper-container--slide-count'}`}
          ref={swiperRef}
          centeredSlides={window.innerWidth <= 1024 ? true : false}
          navigation={true}
          autoplay={autoplay ? swiperAutoplayOptions : false}
          speed={2000}
          loop={window.innerWidth <= 1024 ? true : false}
        >
          {data?.map((item, index) => {
            return (
              <SwiperSlide className='lyt-favourites__swiper-slide' key={index}>
                <ProductTile
                  productId={item.id}
                  productSlug={item.slug}
                  imageUrl={item.thumbnailImageUrl}
                  tagTitle={item.badge}
                  handleAction={() => addToCartHandleChange()}
                  productTitle={item.name}
                  priceValue={item.discount ? item.price - item.discount : null}
                  strikePriceValue={item.price}
                  colorVariants={item?.colors}
                  showAddToCart={showAddToCart}
                  stock={item.stock}
                // setCartData={setCartData}
                // productQty={itemProductQty}
                // stock={itemProductStock}
                // isWishlistActive={isInWishlist}
                />
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
      <div className='lyt-favourites__footer-wrap'>
        <Link
          to={"/products"}
          className='bs-btn bs-btn__btn-solid bs-btn__btn-solid--typ-large'
          onClick={(e) => {
            resetPreSelectedFilters();
            localStorage.removeItem("filterValue");
            localStorage.removeItem("filterKey");
          }}
        >
          {actionTitle}
        </Link>
      </div>
    </div>
  )
}

export default Favourites